import React from 'react'
import DocumentationSidebar from '../component/DocumentationSidebar'
import { useTranslation } from 'react-i18next';
import { useDocImage } from '../hooks/useDocImage';

export default function EmailTemplates() {
  const { t } = useTranslation();
  const image001 = useDocImage('email-templates-img', 'image001.png');
  const image002 = useDocImage('email-templates-img', 'image002.png');
  const image003 = useDocImage('email-templates-img', 'image003.png');
  const image004 = useDocImage('email-templates-img', 'image004.png');
  const image005 = useDocImage('email-templates-img', 'image005.png');
  const image006 = useDocImage('email-templates-img', 'image006.png');

  return (
    <div className="d-flex flex-column main-outer-wrapper">
      <div className="flex-grow-1 d-flex survey-main-wrapper">
        <DocumentationSidebar />

        <div className="flex-grow-1 dashboard-page-outer">
          <div className="dashboard-page-wrap document-page-wrap">
            <h1 className="mt-0 text-primary">{t('documentation.emailTemplates.title')}</h1>
            <p className="header-para">{t('documentation.emailTemplates.intro')}</p>
            <img src={image002} alt={t('documentation.emailTemplates.overview.imageAlt')} className="img-fluid pt-10 pb-30" />

            <div className="card dashboard-card mb-4">
              <div className="card-header d-md-flex justify-content-between align-items-center px-3">
                {t('documentation.emailTemplates.accessing.title')}
              </div>
              <div className="card-body">
                <ul>
                  <li dangerouslySetInnerHTML={{ __html: t('documentation.emailTemplates.accessing.steps.step1') }}></li>
                  <li>
                    <span dangerouslySetInnerHTML={{ __html: t('documentation.emailTemplates.accessing.steps.step2') }}></span>
                    <img src={image001} alt={t('documentation.emailTemplates.accessing.imageAlt')} className="doc-img-native pb-10 pt-10" />
                  </li>
                  <li dangerouslySetInnerHTML={{ __html: t('documentation.emailTemplates.accessing.steps.step3') }}></li>
                </ul>
              </div>
            </div>

            <div className="card dashboard-card mb-4">
              <div className="card-header d-md-flex justify-content-between align-items-center px-3">
                {t('documentation.emailTemplates.overview.title')}
              </div>
              <div className="card-body">
                <p>{t('documentation.emailTemplates.overview.desc')}</p>
              </div>
            </div>

            <div className="card dashboard-card mb-4">
              <div className="card-header d-md-flex justify-content-between align-items-center px-3">
                {t('documentation.emailTemplates.enableDisable.title')}
              </div>
              <div className="card-body">
                <ul>
                  <li>
                    {t('documentation.emailTemplates.enableDisable.items.item1')}
                    <img src={image003} alt={t('documentation.emailTemplates.enableDisable.imageAlt')} className="doc-img-native pt-10 pb-10" />
                  </li>
                  <li>{t('documentation.emailTemplates.enableDisable.items.item2')}</li>
                  <li dangerouslySetInnerHTML={{ __html: t('documentation.emailTemplates.enableDisable.items.item3') }}></li>
                </ul>
              </div>
            </div>

            <div className="card dashboard-card mb-4">
              <div className="card-header d-md-flex justify-content-between align-items-center px-3">
                {t('documentation.emailTemplates.editingContent.title')}
              </div>
              <div className="card-body">
                <p>{t('documentation.emailTemplates.editingContent.intro')}</p>
                <ul>
                  <li>{t('documentation.emailTemplates.editingContent.items.subject')}</li>
                  <li>{t('documentation.emailTemplates.editingContent.items.heading')}</li>
                  <li>{t('documentation.emailTemplates.editingContent.items.description')}</li>
                  <li>{t('documentation.emailTemplates.editingContent.items.button')}</li>
                  <li>{t('documentation.emailTemplates.editingContent.items.securityNote')}</li>
                  <li>{t('documentation.emailTemplates.editingContent.items.assistanceNote')}</li>
                  <li>{t('documentation.emailTemplates.editingContent.items.signoff')}</li>
                  <li>{t('documentation.emailTemplates.editingContent.items.footer')}</li>
                </ul>
              </div>
            </div>

            <div className="card dashboard-card mb-4">
              <div className="card-header d-md-flex justify-content-between align-items-center px-3">
                {t('documentation.emailTemplates.styling.title')}
              </div>
              <div className="card-body">
                <p>{t('documentation.emailTemplates.styling.intro')}</p>
                <img src={image004} alt={t('documentation.emailTemplates.styling.imageAlt')} className="img-fluid pt-10 pb-20" />
                <ul>
                  <li>{t('documentation.emailTemplates.styling.sections.general')}</li>
                  <li>{t('documentation.emailTemplates.styling.sections.heading')}</li>
                  <li>{t('documentation.emailTemplates.styling.sections.description')}</li>
                  <li>{t('documentation.emailTemplates.styling.sections.button')}</li>
                  <li>{t('documentation.emailTemplates.styling.sections.notes')}</li>
                  <li>{t('documentation.emailTemplates.styling.sections.signoff')}</li>
                  <li>{t('documentation.emailTemplates.styling.sections.footer')}</li>
                </ul>
              </div>
            </div>

            <div className="card dashboard-card mb-4">
              <div className="card-header d-md-flex justify-content-between align-items-center px-3">
                {t('documentation.emailTemplates.placeholders.title')}
              </div>
              <div className="card-body">
                <p>{t('documentation.emailTemplates.placeholders.intro')}</p>
                <img src={image005} alt={t('documentation.emailTemplates.placeholders.imageAlt')} className="doc-img-native pt-10 pb-20" />
                <ul>
                  <li dangerouslySetInnerHTML={{ __html: t('documentation.emailTemplates.placeholders.items.orgName') }}></li>
                  <li dangerouslySetInnerHTML={{ __html: t('documentation.emailTemplates.placeholders.items.supportEmail') }}></li>
                  <li dangerouslySetInnerHTML={{ __html: t('documentation.emailTemplates.placeholders.items.reportUrl') }}></li>
                </ul>
              </div>
            </div>

            <div className="card dashboard-card mb-4">
              <div className="card-header d-md-flex justify-content-between align-items-center px-3">
                {t('documentation.emailTemplates.saveReset.title')}
              </div>
              <div className="card-body">
                <img src={image006} alt={t('documentation.emailTemplates.saveReset.imageAlt')} className="doc-img-native pt-10 pb-20" />
                <ul>
                  <li dangerouslySetInnerHTML={{ __html: t('documentation.emailTemplates.saveReset.items.save') }}></li>
                  <li dangerouslySetInnerHTML={{ __html: t('documentation.emailTemplates.saveReset.items.reset') }}></li>
                </ul>
              </div>
            </div>

            <p className="alert alert-info mb-0">{t('documentation.emailTemplates.permissionsNote')}</p>
          </div>
        </div>
      </div>
    </div>
  );
}
